var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"item",staticClass:"item"},[_c('div',{staticClass:"item-rightwrap"},[_c('div',{ref:"scrollingNav",staticClass:"scrollingNav",style:('left:' + _vm.left + 'px')},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }